export default __webpack_public_path__ + "static/media/4a.2aba32d9.png";